import { createGlobalStyle } from 'styled-components';
import * as normalizeCss from 'normalize.css';

const GlobalStyle = createGlobalStyle`
  ${normalizeCss}

  html,
  body {
    background: #e5e5e5;
    margin: 0;
    padding: 0;
    height: 100%;
    font-family: 'Ubuntu', sans-serif;
    font-display: swap;
  }

  body {
    display: flex;
    flex: 1;
  }

  a {
    text-decoration: none;
    cursor: pointer;
  }

  div {
    box-sizing: border-box;
  }

  .blend-multiply * {
    mix-blend-mode: multiply;
  }

  #root {
    display: flex;
    flex: 1;
    flex-direction: column;
    font-family: 'Ubuntu', sans-serif;
  }
`;

export default GlobalStyle;
